/**
 * 模版相关接口
 */
import { post, get } from '@fe/common/lib/ajax';

/**
 * 购买成功，回调editor反向根据模板创建作品
 * @param {string} keyword 关键词
 */
export async function createTamplateApp(body) {
  return await post(`/api/store/app/createApp`, body);
}

/**
 * 获取模板市场活动相关配置
 *
 * @export
 * @return {*}
 */
export async function getActivityConfig() {
  return await get(`/api/store/app/getActivityConfig`);
}
